export default () => ({
  filterDrawer: false,
  products: [],
  auctions: {},

  filterAttributes: {},

  pages: 0,
  page: 1,
  total: 0
})
